import {makeStyles} from '@material-ui/core'
import React from 'react'
import WorkOutlineRoundedIcon from '@material-ui/icons/WorkOutlineRounded'
import ReplayRoundedIcon from '@material-ui/icons/ReplayRounded'
import IcAll from 'assets/svgs/purchase/history/ic-all.svg'
import IcPending from 'assets/svgs/purchase/history/ic-pending.svg'
import IcApproved from 'assets/svgs/purchase/history/ic-complete.svg'
import IcRefunded from 'assets/svgs/purchase/history/ic-cancel.svg'
import {TYPE_PAYMENT_STATUS} from 'pages/ProductsPages/constant'
import PurchaseHistoryListStyle from './style'

type Props = {
  status: string
  value: string
  list: any[]
}
const useStyles = makeStyles(PurchaseHistoryListStyle)
const CardStatus = ({status, value, list}: Props) => {
  const classes = useStyles()
  const getNumberStatus = (status: string) => {
    switch (status) {
      case TYPE_PAYMENT_STATUS.PENDING:
        return list.filter(
          (item) => item.payment.status === TYPE_PAYMENT_STATUS.PENDING,
        ).length
      case TYPE_PAYMENT_STATUS.APPROVED:
        return list.filter(
          (item) => item.payment.status === TYPE_PAYMENT_STATUS.APPROVED,
        ).length
      case TYPE_PAYMENT_STATUS.REFUNDED:
        return list.filter(
          (item) => item.payment.status === TYPE_PAYMENT_STATUS.REFUNDED,
        ).length
      case 'ALL':
        return list.length
      default:
        return 0
    }
  }
  const getIcon = (status: string) => {
    switch (status) {
      case TYPE_PAYMENT_STATUS.PENDING:
        return (
          <div
            style={{
              padding: '12px 16px',
              borderRadius: '50%',
              backgroundColor: 'rgba(170, 227, 187, 0.5)',
              position: 'absolute',
              left: '15%',
            }}
          >
            <img
              src={IcPending}
              alt='pending'
              style={{width: 40, height: 40}}
            />
          </div>
        )
      case TYPE_PAYMENT_STATUS.APPROVED:
        return (
          <div
            style={{
              padding: '12px 16px',
              borderRadius: '50%',
              backgroundColor: 'rgba(233, 228, 179, 0.5)',
              position: 'absolute',
              left: '15%',
            }}
          >
            <img
              src={IcApproved}
              alt='approved'
              style={{width: 40, height: 40}}
            />
          </div>
        )
      case TYPE_PAYMENT_STATUS.REFUNDED:
        return (
          <div
            style={{
              padding: '12px 16px',
              borderRadius: '50%',
              backgroundColor: 'rgba(234, 191, 191, 0.5)',
              position: 'absolute',
              left: '15%',
            }}
          >
            <img
              src={IcRefunded}
              alt='refunded'
              style={{width: 40, height: 40}}
            />
          </div>
        )
      default:
        return (
          <div
            style={{
              padding: '12px 16px',
              borderRadius: '50%',
              backgroundColor: 'rgba(182, 196, 227, 0.5)', // 50% opacity of #5d7bc0
              position: 'absolute',
              left: '15%',
            }}
          >
            <img src={IcAll} alt='all' style={{width: 40, height: 40}} />
          </div>
        )
    }
  }
  return (
    <div className={classes.cardStatus}>
      {getIcon(value)}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <span> {getNumberStatus(value)}</span>
        <span>{status}</span>
      </div>
    </div>
  )
}

export default CardStatus
